export default "__VITE_ASSET__cfNyorx___"